import { Button, Col, FormGroup, Input, Label, Row, Table } from "reactstrap";
import FullScreenLoader from "../../../../components/FullScreenLoader/FullScreenLoader";
import "./styles.css";
import DatePicker from "react-datepicker";
import { ptBR } from "date-fns/locale";
import { useContext, useState } from "react";
import { toast } from "react-toastify";
import api from "../../../../services/axiosConfig";
import { Context } from "../../../../hooks/useAuthContext";
import { formatarMoedaDolar } from "../../../../utils/formatMoeda";
import { format } from "date-fns";

function Ranking() {
  const { exibirLogs } = useContext(Context);

  const [selectedDate, setSelectedDate] = useState();
  const [selectedEndDate, setSelectedEndDate] = useState();
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(10);
  const [checked, setChecked] = useState(false);
  const [buscou, setBuscou] = useState(false);
  const [receitasUsuarios, setReceitasUsuarios] = useState([]);
  const [tipoConta, setTipoConta] = useState("");

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setChecked(isChecked);
    if (isChecked) {
      setLimit(receitasUsuarios.length);
    } else {
      setLimit(10);
    }
  };

  async function fetchReceitasRanking() {
    if (!selectedDate || !selectedEndDate) {
      toast.warning("Selecione uma data antes de buscar.");
      return;
    }

    setLoading(true);
    setBuscou(true);

    try {
      const params = {};

      if (selectedDate) {
         params.dataInicio = format(selectedDate, 'yyyy-MM-dd');
      }

      if (selectedEndDate) {
        params.dataFim = format(selectedEndDate, 'yyyy-MM-dd');
      }

      if (tipoConta) {
        params.tipoConta = tipoConta;
      }

      const response = await api.get("/admin/usuarios-ranking", { params });
      setReceitasUsuarios(response.data || []);
    } catch (error) {
      exibirLogs && console.error("Erro ao buscar receitas:", error);
      toast.error("Erro ao buscar dados.");
      setReceitasUsuarios([]);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading && <FullScreenLoader />}
      <div>
        <h3 className="titleDash">Todos os relatórios</h3>
        <Row>
          <Col md={2}>
            <FormGroup className="filterGroup">
              <label htmlFor="filter">Data inicio:</label>
              <DatePicker
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                dateFormat="dd/MM/yyyy"
                locale={ptBR}
                className="dateInputDash"
                placeholderText="Selecione uma data"
              />
            </FormGroup>
          </Col>
          <Col md={2}>
            <FormGroup className="filterGroup">
              <label htmlFor="filter">Data final:</label>
              <DatePicker
                selected={selectedEndDate}
                onChange={(date) => setSelectedEndDate(date)}
                dateFormat="dd/MM/yyyy"
                locale={ptBR}
                className="dateInputDash"
                placeholderText="Selecione uma data"
              />
            </FormGroup>
          </Col>

          <Col md={2}>
            <FormGroup className="filterGroup">
              <label htmlFor="filter">Tipo de conta:</label>
              <Input
                type="select"
                id="filter"
                value={tipoConta}
                onChange={(e) => setTipoConta(e.target.value)}
              >
                <option value="">Usuário e Influenciador</option>
                <option value="usuario">Usuário</option>
                <option value="influenciador">Influenciador</option>
              </Input>
            </FormGroup>
          </Col>
          <Col md={2} sm={6} xs={6}>
            <FormGroup className="filterGroup">
              <br />
              <Button color="success" block onClick={fetchReceitasRanking}>
                Buscar
              </Button>
            </FormGroup>
          </Col>
        </Row>

        <div className="tableResponsive">
          {loading ? (
            <div>Loading...</div>
          ) : (
            <Table striped bordered responsive>
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Impressões</th>
                  <th>Receitas</th>
                  <th>Tipo de conta</th>
                </tr>
              </thead>
              <tbody>
                {receitasUsuarios.length > 0 ? (
                  receitasUsuarios
                    .sort(
                      (a, b) =>
                        b.receitas.totalReceita - a.receitas.totalReceita
                    )
                    .slice(0, limit)
                    .map((receita) => (
                      <tr key={receita.id}>
                        <td>{receita.nome}</td>
                        <td>{receita.receitas.totalImpressoes || 0}</td>
                        <td>
                          ${" "}
                          {formatarMoedaDolar(receita.receitas.totalReceita) ||
                            formatarMoedaDolar(0)}
                        </td>
                        <td>{receita.tipoConta || "Sem dados"}</td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      {buscou
                        ? "Nenhum dado encontrado para a data selecionada."
                        : "Nenhuma busca realizada ainda."}
                    </td>
                  </tr>
                )}
              </tbody>
              <tfoot className="rowFooter">
                <tr>
                  <td colSpan="5" style={{ width: "100%" }}>
                    <div
                      style={{
                        display: "flex",
                        gap: 10,
                        alignItems: "center",
                        width: "100%",
                        justifyContent: "flex-start",
                      }}
                    >
                      {receitasUsuarios.length > 0 ? (
                        <span>{`Mostrando ${
                          limit > receitasUsuarios.length
                            ? receitasUsuarios.length
                            : limit
                        } de ${receitasUsuarios.length}`}</span>
                      ) : (
                        "0 registros"
                      )}

                      {receitasUsuarios.length > 0 && (
                        <Label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 5,
                            marginBottom: 3,
                          }}
                        >
                          <Input
                            type="checkbox"
                            checked={checked}
                            onChange={handleCheckboxChange}
                            className="ms-2"
                            valid
                          />
                          <span>Mostrar todas</span>
                        </Label>
                      )}
                    </div>
                  </td>
                </tr>
              </tfoot>
            </Table>
          )}
        </div>
      </div>
    </>
  );
}

export default Ranking;
